/**
 * A Palm Shop — Product Page Scripts
 */
(function () {

  /* ── HELPERS ──────────────────────────────────────── */

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    });
  }

  function getAllVariants() {
    const el = document.querySelector('[data-all-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getVariantFromSelects(variants) {
    const selects = Array.from(document.querySelectorAll('select[name^="options["]'));
    if (!selects.length) return null;
    const chosen = selects.map(s => s.value);
    return variants.find(v =>
      v.options.length === chosen.length &&
      v.options.every((opt, i) => opt === chosen[i])
    ) || null;
  }

  function isBundle() {
    return document.querySelector('product-info[data-template-suffix="bundle"]') !== null;
  }

  /* ── INSTANT PRICE UPDATE ──────────────────────────── */

  function applyPrice(variant) {
    if (!variant) return;

    const priceContainer = document.querySelector('[id^="price-"]');
    if (!priceContainer) return;

    const price     = formatPrice(variant.price);
    const compareAt = variant.compare_at_price;
    const onSale    = compareAt && compareAt > variant.price;

    const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
    if (regularEl) regularEl.textContent = price;

    const saleEl = priceContainer.querySelector('.price-item--sale');
    if (saleEl) saleEl.textContent = price;

    const compareEl = priceContainer.querySelector('.price__sale .price-item--regular');
    if (compareEl) compareEl.textContent = onSale ? formatPrice(compareAt) : '';

    const regularDiv = priceContainer.querySelector('.price__regular');
    const saleDiv    = priceContainer.querySelector('.price__sale');
    if (regularDiv) regularDiv.style.display = onSale ? 'none' : '';
    if (saleDiv)    saleDiv.style.display    = onSale ? '' : 'none';
  }

  function initInstantPrice() {
    const variants = getAllVariants();
    if (!variants.length) return;

    document.addEventListener('change', (e) => {
      if (!e.target.matches('select[name^="options["]')) return;
      const variant = getVariantFromSelects(variants);
      if (variant) applyPrice(variant);
    });

    if (typeof subscribe === 'function') {
      subscribe('variant-change', (data) => {
        const variant = data?.data?.variant || data?.variant;
        if (variant) {
          const match = variants.find(v => v.id === variant.id);
          if (match) applyPrice(match);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initInstantPrice);


  /* ── LAYOUT ENFORCER ──────────────────────────────── */

  function applyGridStyles() {
    const grid = document.querySelector('.product.grid.grid--2-col-tablet');
    if (!grid) return;

    if (window.innerWidth < 750) {
      grid.style.removeProperty('flex-wrap');
      grid.style.removeProperty('gap');
      grid.style.removeProperty('align-items');
      grid.style.setProperty('flex-direction', 'column', 'important');
      const media = grid.querySelector('.product__media-wrapper');
      if (media) {
        media.style.setProperty('width', '100%', 'important');
        media.style.setProperty('flex', 'none', 'important');
        media.style.setProperty('min-width', '100%', 'important');
        media.style.setProperty('max-width', '100%', 'important');
        media.style.removeProperty('margin-left');
        media.style.removeProperty('padding-left');
      }
      const info = grid.querySelector('.product__info-wrapper');
      if (info) {
        info.style.setProperty('width', '100%', 'important');
        info.style.setProperty('flex', 'none', 'important');
        info.style.setProperty('min-width', '100%', 'important');
        info.style.setProperty('max-width', '100%', 'important');
        info.style.setProperty('padding', '2.4rem 0 0', 'important');
      }
      return;
    }

    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const pw = productInfo.querySelector('.page-width');
      if (pw) {
        pw.style.setProperty('max-width', '1400px', 'important');
        pw.style.setProperty('width', '100%', 'important');
        pw.style.setProperty('margin', '0 auto', 'important');
      }
    }

    grid.style.setProperty('display', 'flex', 'important');
    grid.style.setProperty('flex-wrap', 'nowrap', 'important');
    grid.style.setProperty('width', '100%', 'important');
    grid.style.setProperty('max-width', '100%', 'important');
    grid.style.setProperty('gap', '5rem', 'important');
    grid.style.setProperty('align-items', 'flex-start', 'important');
    grid.style.setProperty('margin', '0', 'important');

    const media = grid.querySelector('.product__media-wrapper');
    if (media) {
      if (isBundle()) {
        media.style.setProperty('flex', 'none', 'important');
        media.style.setProperty('width', '800px', 'important');
        media.style.setProperty('min-width', '800px', 'important');
        media.style.setProperty('max-width', '800px', 'important');
        media.style.setProperty('padding-left', '60px', 'important');
        media.style.setProperty('box-sizing', 'border-box', 'important');
      } else {
        media.style.setProperty('flex', '1.46 1 0%', 'important');
        media.style.setProperty('width', '0', 'important');
        media.style.setProperty('min-width', '0', 'important');
        media.style.setProperty('max-width', 'none', 'important');
        media.style.setProperty('flex-shrink', '1', 'important');
        media.style.removeProperty('padding-left');
        media.style.removeProperty('margin-left');
      }
    }

    const info = grid.querySelector('.product__info-wrapper');
    if (info) {
      const bundle = isBundle();
      info.style.setProperty('flex', bundle ? '0 0 400px' : '0 0 360px', 'important');
      info.style.setProperty('width', bundle ? '400px' : '360px', 'important');
      info.style.setProperty('min-width', bundle ? '400px' : '360px', 'important');
      info.style.setProperty('max-width', bundle ? '400px' : '360px', 'important');
      info.style.setProperty('flex-shrink', '0', 'important');
      info.style.setProperty('padding', '0', 'important');
    }

    if (isBundle()) {
      grid.style.setProperty('justify-content', 'center', 'important');
    } else {
      grid.style.removeProperty('justify-content');
    }
  }

  function enforceBundleSize() {
    if (!isBundle()) return;
    const media = document.querySelector('.product__media-wrapper');
    if (!media) return;
    media.style.setProperty('flex', 'none', 'important');
    media.style.setProperty('width', '800px', 'important');
    media.style.setProperty('min-width', '800px', 'important');
    media.style.setProperty('max-width', '800px', 'important');
    media.style.setProperty('padding-left', '60px', 'important');
    media.style.setProperty('box-sizing', 'border-box', 'important');
    const info = document.querySelector('.product__info-wrapper');
    if (info) {
      info.style.setProperty('flex', '0 0 400px', 'important');
      info.style.setProperty('width', '400px', 'important');
      info.style.setProperty('min-width', '400px', 'important');
      info.style.setProperty('max-width', '400px', 'important');
    }
    const grid = document.querySelector('.product.grid.grid--2-col-tablet');
    if (grid) {
      grid.style.setProperty('justify-content', 'center', 'important');
      grid.style.setProperty('align-items', 'flex-start', 'important');
    }
  }

  function startLayoutWatcher() {
    applyGridStyles();
    const grid = document.querySelector('.product.grid.grid--2-col-tablet');
    if (!grid) return;
    let locked = false;
    new MutationObserver(() => {
      if (locked) return;
      locked = true;
      applyGridStyles();
      requestAnimationFrame(() => { locked = false; });
    }).observe(grid, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
  }

  document.addEventListener('DOMContentLoaded', startLayoutWatcher);
  window.addEventListener('load', () => {
    applyGridStyles();
    setTimeout(applyGridStyles, 200);
    setTimeout(applyGridStyles, 500);
    setTimeout(enforceBundleSize, 100);
    setTimeout(enforceBundleSize, 600);
    setTimeout(enforceBundleSize, 1200);
  });


  /* ── THUMBNAIL CONTROL ─────────────────────────────
   * Thumbnail count is now handled entirely in Liquid
   * (product-media-gallery.liquid) — no JS hiding needed.
   * ──────────────────────────────────────────────────── */


  /* ── QUANTITY WIDGET ──────────────────────────────── */

  function buildQuantityWidget() {
    if (document.querySelector('.apalm-quantity')) return;
    if (isBundle()) return;
    const submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return;

    const widget = document.createElement('div');
    widget.className = 'apalm-quantity';

    const label = document.createElement('div');
    label.className = 'apalm-quantity__label';
    label.textContent = 'Quantity';

    const row = document.createElement('div');
    row.className = 'apalm-quantity__row';

    const minus = document.createElement('button');
    minus.className = 'apalm-quantity__btn';
    minus.type = 'button';
    minus.textContent = '−';

    const val = document.createElement('div');
    val.className = 'apalm-quantity__value';
    val.textContent = '1';

    const plus = document.createElement('button');
    plus.className = 'apalm-quantity__btn';
    plus.type = 'button';
    plus.textContent = '+';

    let qty = 1;

    function getQtyInput() { return document.querySelector('input[name="quantity"]'); }

    minus.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      val.textContent = qty;
      const inp = getQtyInput();
      if (inp) { inp.value = qty; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    plus.addEventListener('click', () => {
      qty++;
      val.textContent = qty;
      const inp = getQtyInput();
      if (inp) { inp.value = qty; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    row.appendChild(minus);
    row.appendChild(val);
    row.appendChild(plus);
    widget.appendChild(label);
    widget.appendChild(row);

    document.querySelectorAll('.product-form__quantity, [id^="Quantity-Form-"]').forEach(el => el.style.display = 'none');
    submitBtn.parentNode.insertBefore(widget, submitBtn);
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(buildQuantityWidget, 300);

    if (isBundle()) {
      const updateBundleBtn = () => {
        const btn = document.querySelector('.product-form__submit span:first-child');
        if (btn && btn.textContent.toLowerCase().includes('add to cart')) {
          btn.textContent = 'Add this bundle to cart';
        }
      };
      updateBundleBtn();
      setTimeout(updateBundleBtn, 500);
      setTimeout(updateBundleBtn, 1000);
    }
  });

})();
